/* Component Dependencies */
var adaraAdsTemplate = require('templates/adaraAds.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');

PubSub.register(AriesComponent.extend({
  type: 'adaraAds',
  template: {
    'adaraAds': adaraAdsTemplate
  },
  bindEvents: function($) {
    var $window = $(window),
        mobileWrapper = $('iframe.tile-visibilty-mob').closest('section');
        desktopWrapper = $('iframe.tile-visibilty-desktop').closest('section');
    $window.on('load resize', function () {
      if(mobileWrapper.length){
        if($window.width() < 769) {
           $(mobileWrapper).hide();
        } else {
          $(mobileWrapper).show();
        }
      }

      if(desktopWrapper.length){
        if($window.width() > 1025) {
           $(desktopWrapper).hide();
        } else {
          $(desktopWrapper).show();
        }
      }
    });
  }
}));
